import {
    mockState,
    mockRootState,
    mockGetters,
    ICurrencyActionsMock,
    IServiceActionsMock,
    ITravelActionsMock,
    IInfoActionsMock,
    ICustomerActionsMock,
    IModalActionsMock,
    IRequestActionsMock,
    IPaymentActionsMock,
    IPromoCodeActionsMock
} from '../index'
import {
    Context,
    IActionsMock
} from './index'

export const mockActionsContext = (): Context => ({
    commit: jest.fn(),
    dispatch: jest.fn(),
    state: mockState(),
    getters: mockGetters(),
    rootState: mockRootState(),
    rootGetters: {}
})

export const mockCurrencyActions = (): ICurrencyActionsMock => ({
    fetchCurrencies: jest.fn(),
    setCurrency: jest.fn(),
    getPrice: jest.fn()
})

export const mockServiceActions = (): IServiceActionsMock => ({
    fetchServiceTypes: jest.fn(),
    getServiceTypeById: jest.fn(),
    fetchServiceTypePrices: jest.fn(),
    getServiceTypePriceById: jest.fn(),

    fetchSolutions: jest.fn(),
    getSolutionById: jest.fn(),

    setRequestServiceContact: jest.fn(),
    getRequestServiceHistories: jest.fn()
})

export const mockTravelActions = (): ITravelActionsMock => ({
    fetchTravels: jest.fn(),
    getTravelById: jest.fn(),
    getTravelLimits: jest.fn(),

    // criteria
    fetchCriterion: jest.fn(),

    fetchAccommodation: jest.fn(),
    getAccommodationById: jest.fn(),

    fetchTravelType: jest.fn(),
    getTravelTypeById: jest.fn(),

    fetchTaste: jest.fn(),
    getTasteById: jest.fn(),

    fetchLocation: jest.fn(),
    getLocationById: jest.fn(),

    fetchSeason: jest.fn(),
    getSeasonById: jest.fn()
})

export const mockPartnerActions = (): IInfoActionsMock => ({
    fetchPartners: jest.fn(),
    getPartnerById: jest.fn(),

    fetchContactWays: jest.fn(),
    getContactWayById: jest.fn(),

    fetchFaqItems: jest.fn(),
    getFaqItemById: jest.fn(),

    fetchNews: jest.fn(),
    getNewsById: jest.fn(),

    fetchBeautyPlaces: jest.fn(),
    getBeautyPlaceById: jest.fn()
})

export const mockCustomerActions = (): ICustomerActionsMock => ({
    addContactRequest: jest.fn()
})

export const mockModalActions = (): IModalActionsMock => ({
    setModal: jest.fn(),
    closeModal: jest.fn()
})

export const mockRequestActions = (): IRequestActionsMock => ({
    addServiceOrder: jest.fn(),
    addPublicPlanOrder: jest.fn(),
    addPlanOrder: jest.fn(),
    addSolutionOrder: jest.fn(),
    addPromoCodeOrder: jest.fn(),

    getOrderByToken: jest.fn(),
    addConsultationInfo: jest.fn(),
    getOrderHistories: jest.fn(),
    getRequestTravelHistories: jest.fn(),
    appendService: jest.fn(),
    cancelOrder: jest.fn(),

    setOrder: jest.fn()
})

export const mockPaymentActions = (): IPaymentActionsMock => ({
  checkout: jest.fn()
})

export const mockPromoCodeActions = (): IPromoCodeActionsMock => ({
    fetchPromoCodes: jest.fn(),
    getRequestPromoCodeHistories: jest.fn()
})

export const mockActions = (): IActionsMock => ({
    ...mockCurrencyActions(),
    ...mockServiceActions(),
    ...mockTravelActions(),
    ...mockPartnerActions(),
    ...mockCustomerActions(),
    ...mockModalActions(),
    ...mockRequestActions(),
    ...mockPaymentActions(),
    ...mockPromoCodeActions(),
    updatePlatformInfo: jest.fn(),
    setLoading: jest.fn(),
    setTheming: jest.fn(),
    setTheme: jest.fn(),
    setTravel: jest.fn(),
    setFilters: jest.fn()
})
